module.exports = __webpack_public_path__ + "static/media/woman.c3e34c94.jpg";